import { render, staticRenderFns } from "./ListPackaging.vue?vue&type=template&id=f1f1fcca"
import script from "./ListPackaging.vue?vue&type=script&lang=js"
export * from "./ListPackaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports